module.exports = __webpack_public_path__ + "components/modal-app-popup/static/unknown-icon-2d4b12f504289ddae2315b01b31bfbae.webp";